var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 269.3 583.1",
    style: {
      enableBackground: "new 0 0 269.3 583.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83B3E2;}\n\t.st1{fill:#D0DE8E;}\n\t.st2{fill:#D03632;}\n\t.st3{fill:#F9DB00;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st5{fill:#1F54B0;}\n\t.st6{fill:#D1D1D1;}\n\t.st7{fill:#4C702B;}\n\t.st8{fill:#93B838;}\n\t.st9{fill:#B1CC40;}\n\t.st10{fill:#CAF741;}\n\t.st11{fill:#FEF7CE;}\n\t.st12{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wasser"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,475.1c1.8-8.9-9.4-15.5-2-27c4.4-5.9,8.2-8.1,14.3-11.1c4.9-2.5,10.4-3.7,15.9-3.5 c10.3,0.8,9.1,3.7,8.1,7.9c-0.6,2.6-0.8,4,0.3,8.9c1.3,6-5.5,16.1-4.2,21.6c0,0-0.8,7.7,9.7,18.3s12,31.6,12,31.6s1,3.5,10.4,12.1 s21.1,24.3,16.7,37.6s-5.6,11.8-9.6,11.1s-8.1-3.9-8.1-3.9s-1.7-1.9,0.2-5.2s6.6-12-2.7-21.9s-22.3,0.1-22.3,0.1s-4.1,4.9-12.2,1 c-2.8-1.3-10.2-2-15-2.2c0,0-6.7-0.5-8.2-5.4s6-8.2,6-8.2s4.3-3.1,0.5-5.8c0,0-8.1-2-8-9.9s2.7-9.3,2.3-11.8s0.2-2.5-7.4-6.3 s-1.6-13.4-1.6-13.4S180,481.1,181.3,475.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "105.2,146.7 71.9,231.2 68.6,229.2 101.4,145.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "102.6,142.3 158,0 162.1,1.7 106.3,143.7  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.4,524.2c-0.9-5.6,0.1-7,3.4-7.6c3.9-0.5,4.9,0.2,5.9,6.3c0.8,5.1-0.1,6.7-3.9,7.5 C167,530.9,166.1,528.5,165.4,524.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.8,454.2c6.6-1.5,7.3,4.6,7.7,6.4s0.9,5.6,1.4,9.5c0.3,2.2,1.5,6.1-2.4,7.2c-5.7,1.5-6.7-2.5-7.3-4.5 c-0.5-1.7-2-7.8-2.4-9.6S150.8,455.6,155.8,454.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.7,424.7c-0.1-1.3-0.6-5.5-0.6-6.8c-0.1-2.5,0-4.5,0.9-6.1c1-1.8,3-2.9,5.1-2.8c6.1,0,6.5,6.6,6.6,8.8 c0,0.7,0.3,6.6,0.3,6.9c0,1.2,0.5,7.9-6.1,8.1C143.8,432.7,143.8,426,143.7,424.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.1,415.2c0,2.3-1.9,4.1-4.1,4.1s-4.1-1.9-4.1-4.1c0-2.3,1.9-4.1,4.1-4.1 C151.2,411.1,153.1,412.9,153.1,415.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163.6,470.9c0,2.1-1.7,3.8-3.7,3.8s-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.7-3.8c0,0,0,0,0,0 C162,467.1,163.6,468.8,163.6,470.9C163.6,470.9,163.6,470.9,163.6,470.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.6,523.7c0,2.1-1.7,3.8-3.7,3.8c-2.1,0-3.8-1.7-3.8-3.7c0-2.1,1.7-3.8,3.7-3.8c0,0,0,0,0,0 C171.9,519.9,173.6,521.6,173.6,523.7C173.6,523.7,173.6,523.7,173.6,523.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M152.9,428.3c0,2.1-1.7,3.8-3.7,3.8s-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.7-3.8c0,0,0,0,0,0 C151.2,424.6,152.9,426.3,152.9,428.3C152.9,428.3,152.9,428.3,152.9,428.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Weg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111.7,422.1c4.6-1.4,8.8-3.9,12.1-7.4c5.5-5.6,9.4-10.7,9.4-10.7l-1.9-1.5l-0.2,0.2c-0.8,1-4.4,5.5-9.1,10.3 c-2.2,2.2-4.7,4-7.5,5.4c-0.8,0.4-1.7,0.8-2.6,1.1c-0.3,0.1-0.6,0.2-0.7,0.2l-0.2,0l0,0L111.7,422.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M162.4,545.1c-0.2-2.6-0.4-5.4-0.7-8.1c-0.7-8-1.5-16.3-2.3-23.3c-0.5-5.3-1.3-10.6-2.4-15.8 c-1.5-5.7-4.5-12.4-7.6-18.3s-6.1-11.2-7.7-14c-3-5.2-5.7-10.6-7.9-16.2c-1.1-2.9-2-5.9-2.6-9c-2.1-8.7-5.8-13.8-9.6-16.7 c-2.8-2.2-6.2-3.5-9.7-3.7l0,0c-4-0.2-22.4-0.6-22.4-0.6v2.4l3,0.1c5.4,0.1,16.5,0.4,19.4,0.5l0,0c3,0.2,5.9,1.3,8.3,3.1 c3.3,2.5,6.7,7,8.7,15.3c0.7,3.2,1.6,6.3,2.7,9.3c2.2,5.7,4.9,11.2,8,16.5c1.6,2.9,4.7,8.1,7.7,14s6,12.4,7.4,17.8 c1.1,5.1,1.8,10.2,2.3,15.4c1.1,9.4,2.1,21.1,3,31.2c0,0,0.5,0.8,1.2,0S162.4,545.1,162.4,545.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M162.7,3c0,0,1.3,0.7,2.9,1.6s3.5,2,4.7,2.7c2.2,1.4,4.1,3.2,5.6,5.4c3.2,4.6,6.1,9.5,8.8,14.4 c3.4,6.1,11.7,20.4,14.5,25c1.5,2.9,2.5,6,3,9.3c1.1,6.4,1.8,12.8,2.2,19.3c0.5,6.5,0.9,12.3,1.8,16.1c1.9,8.2,6.7,26.9,6.7,26.9 l2.3-0.6l-0.8-3c-1.4-5.6-4.5-17.7-5.9-23.8c-0.6-3.1-1-6.3-1.2-9.5c-0.5-5.9-0.9-12.9-1.7-19.4s-2-12.5-4.3-16.3 c-2.7-4.7-11-18.9-14.4-24.9l0,0c-2.7-5.1-5.7-10-8.9-14.7c-1.7-2.4-3.8-4.4-6.2-5.9c-2.5-1.7-7.7-4.4-7.7-4.4L162.7,3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M133.9,90.5c-2.7,8.5-5.2,22.9-11.4,38.5c-5.4,13.5-14.5,18-20.9,48.2c-4.5,21.1-10.9,20-13.2,32.1 c-2.5,12.9,2.7,22.1,8.5,63.1c5,35.6,2.9,49.9,15.4,63.7c6.8,7.5,18.2,8.7,24.4,7.7c7.9-1.3,21.8-7.6,22.4-24.1c0-5-1-27.1,1-38.8 c1.7-10.3,11-25.7,5.5-39.8c-3.8-12.3-1.6-20.9,4.1-29.6c5.6-8.1,10.7-15.3,10-32.1c-0.3-7-3.5-19.7-1.3-28.9 c2.8-11.9,8.1-19.9,9.1-31.8s3-27.1,8.2-40c2.8-6.9,7.2-16.2-5.5-38.8c-5.8-10.4-21.4-16.4-30.8-12 C147.1,33.8,139.1,73.8,133.9,90.5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M141.1,98.5c-4.1,11.8-5.1,19.1-8,33s-11.2,27.6-15.6,43.5c-2.2,8-4.1,20-8.1,30.1c-1.4,3.5-3.8,6.6-5.7,12 c-4.1,11.4,2.6,23.4,4.1,32.6c1.9,11.5,3.6,20.4,4.5,27.3c1.4,11.6,1.3,19.7,2.2,27.3c1.8,14.5,6.8,16.2,19.2,13.2 c17.5-4.2,17.1-7.7,9.8-34.4c-5.5-20.2-6-19.3-6.1-21.8c0-1.4,1-1.7,0.7-3.6s-3.3-2.2-4.7-9c-2.8-13.5-0.9-20.2,1.9-25.2 c2.2-3.9,7.7-14.3,7.7-21.1c0.1-22.1,4.6-25.5,11.7-48.4c5.7-18.2,10.8-37.4,5.4-51.4C154.6,101.1,146.8,99.6,141.1,98.5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M184.5,75c0.8-5.2,2.3-11-6.1-15c-5.6-2.7-6.1-5-5.9-10.4c0.2-3.5,3.1-10.6-3.8-13.1c-6.3-2.3-7.4,1.9-7.9,5.2 c-1.2,7.8-5.1,7.2-6.3,11.3c-1.9,6.7,3.1,9.7,1.9,13.9c-1.3,4.8-4,6.4-5.7,9.7c-1.9,3.6-1.6,5-3.3,8.4c-1.2,2.4-3.2,4.3-6.1,12.3 c-2.1,5.8-2.1,9.6,7.7,11.9c5.6,1.3,16,2.6,9.4-10c-2.2-4.2-1.2-9,4.6-11.3s9.2,2.7,16.3-1.8C183,84,183.8,79.5,184.5,75"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M182,75.8c1-6.2,1.7-10.8-4-13.4c-10.6-5-5.9-11.6-12.9-13.2c-3.6-1-7.3,1-8.4,4.6c-0.1,0.3-0.2,0.7-0.2,1 c-0.6,4,2.6,5.6,2.8,11.6c-0.7,7-11.2,12.9-6.2,19.1s8.8-2,15.9-0.1C179,87.9,181.4,80,182,75.8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M138.3,262.7c-2.4-2.4,1.9-4.1-1.5-7.1c-2.3-2.1-2.5-4.9,1.3-5.8c2.8-0.7,2.5-1.8,2.4-4.6 c-0.1-3.2,4.6-5.2,8.8-4.5c1.9,0.3,4.5,1.3,4.4,3.8c-0.2,3.2-4.9,3.2-5.4,9.2s-2.7,7.8-3.8,8.6 C143.7,262.8,140.5,264.9,138.3,262.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M140.5,229.7c-3-3.4-1-7.3,2.2-8.6c1-0.4,3.4-1.5,3.9-3.1c0.9-3.1-1-7.3,0.5-10.2c1.7-3.5,3.3-3.6,7.7-1.8 c6,2.4,5.8,4.7,3.4,8.2c-5.1,7.3,2.4,9.4-1.7,14.1c-3.8,3.3-5.1,0.5-7.6,0.5C145.4,228.9,143.1,233,140.5,229.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M149.7,192.3c-2.3-3.9,0.4-6.8,3.5-7.5c1.6-0.3,4.4-0.6,4.3-3.8c-0.2-2,0.7-3.9,2.3-5.1 c0.9-0.8,3.1-1.7,6.2-0.6c4.8,1.8,2.2,6.1,0.9,8.2s-4,7.1-6.3,8.7C157.6,194.7,151.8,195.9,149.7,192.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M98.8,214.5c2.2,0.8,3.4,0,4.4-2.3c1.6-3.8,4-3.6,5.3-5.9s1.8-5.4-0.6-6.6c-5.3-2.5-7.3,3.8-8.8,6.1 S94.3,212.7,98.8,214.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M164,99.1c1.2,0,2.4,0.3,3.4,1.1c1.4,0.8,4.3,0.8,7.1-2.7c2.2-3.2,2.1-5.4,1.6-6.7c-0.8-2-2.7-1.4-4.7,0.4 c-1.5,1.3-2.6,2.3-4.4,2.2c-1.6-0.1-3.3-1.7-5.2-1.4c-2.4,0.4-3.9,2.7-2.1,5.5C160.9,99.2,162.8,99.1,164,99.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M144.5,64c0.9,1.2,1.3,2.8,1.1,4.3c-0.1,1.4-0.7,4.5,2.8,5s5.6-3.2,4.5-5.9c-0.7-1.9-1.3-2.8-0.2-5.8 c0.9-2.5,1.4-2.7,0.7-5.7c-0.9-3.5-5.7-4.8-8.1-0.1C143.7,58.9,142.8,61.9,144.5,64"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M188.1,440.2c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4c0,0,0,0,0,0 C186.5,436.8,188,438.3,188.1,440.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "114.1,451.3 88.8,448.8 82.9,437.3 90.1,426.3 116.5,428.7 127.6,453.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "119.4,407 116,395 115.6,385.3 105.6,390 106.9,399.7 93.7,402.2 85.5,411.5 111.4,413.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M185.1,333.8c-0.6-0.1-1.3-0.1-1.9,0.2c-1.7,0.7-2.5,2.7-1.8,4.4c0.6,1.4,2.1,2.3,3.6,2 c-1.5,1.1-1.8,3.2-0.7,4.7s3.2,1.8,4.7,0.7c0.8-0.6,1.3-1.5,1.4-2.5l0.1,0h0.1c0,0.4,0.1,0.8,0.2,1.1c0.7,1.7,2.7,2.5,4.4,1.8 c1.7-0.7,2.5-2.7,1.8-4.4c-0.7-1.6-2.5-2.5-4.2-1.9c1.5-1.1,1.8-3.2,0.7-4.7c-0.5-0.7-1.3-1.2-2.2-1.3c0.7-1.7,0-3.7-1.7-4.4 c-1.7-0.7-3.7,0-4.4,1.7C184.8,332.1,184.8,333,185.1,333.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M169.2,301.7c-1.4,1.2-1.5,3.4-0.2,4.7c1.2,1.4,3.4,1.5,4.7,0.2c0.1-0.1,0.3-0.2,0.4-0.4c0,0.2,0,0.4,0,0.6 c0.1,1.8,1.8,3.2,3.6,3.1c1.8-0.1,3.2-1.8,3.1-3.6c0-0.1,0-0.2,0-0.2c-0.1-1-0.7-1.9-1.6-2.4c0.1-0.2,0.2-0.4,0.4-0.7 c0.6,0.3,1.2,0.4,1.9,0.3c1.8-0.2,3.1-1.9,2.9-3.7c1.3,1.3,3.5,1.2,4.7-0.1c0.7-0.7,1-1.7,0.9-2.7c-0.2-1.4-1.2-2.6-2.6-2.9 c1.1-0.7,1.8-2,1.6-3.3c-0.2-1.5-1.3-2.7-2.9-2.9c1.4-1.2,1.7-3.3,0.5-4.7c-0.5-0.6-1.1-1-1.8-1.2c1-1.5,0.6-3.6-1-4.6 c-0.4-0.3-0.8-0.4-1.3-0.5c0.3-0.6,0.4-1.2,0.3-1.9c-0.3-1.8-2-3.1-3.8-2.8c-1.7,0.3-3,1.8-2.8,3.6c0.1,0.4,0.2,0.9,0.4,1.2h-0.4 c-1.9,0.2-3.2,1.9-3,3.7c0,0,0,0,0,0c0,0.3,0.1,0.6,0.2,0.9c-1.8,0.3-3.1,2-2.9,3.8s2,3.1,3.8,2.9l0,0h0.1 c-0.3,0.6-0.4,1.2-0.3,1.8c0.1,0.7,0.4,1.3,0.8,1.8c-0.1,0-0.3,0-0.4,0c-1.8,0.2-3.2,1.9-2.9,3.7v0.1c-0.3,0-0.6,0-0.9,0 c-1.8,0.2-3.1,1.9-2.9,3.7C167.9,300.3,168.3,301.1,169.2,301.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M176.2,527.2c-0.4-2.5,1.3-4.9,3.8-5.3c2.5-0.4,4.9,1.3,5.3,3.8c0.4,2.5-1.3,4.9-3.8,5.3c0,0,0,0,0,0 C179,531.5,176.6,529.7,176.2,527.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M172.8,488.2c-0.4-2.5,1.3-4.9,3.8-5.3c2.5-0.4,4.9,1.3,5.3,3.8c0.4,2.5-1.3,4.9-3.8,5.3c0,0,0,0,0,0 C175.6,492.4,173.2,490.7,172.8,488.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M78.1,307.6c2.7,2.2,3.1,6.2,0.9,8.9s-6.2,3.1-8.9,0.9c-2.7-2.2-3.1-6.2-0.9-8.9 C71.4,305.8,75.4,305.4,78.1,307.6C78.1,307.6,78.1,307.6,78.1,307.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M76.3,297.6c2.7,2.2,3.1,6.2,0.9,8.9c-2.2,2.7-6.2,3.1-8.9,0.9c-2.7-2.2-3.1-6.2-0.9-8.9 C69.6,295.8,73.6,295.4,76.3,297.6C76.3,297.6,76.3,297.6,76.3,297.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M152.5,505.9c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C149.6,499.6,152.5,502.4,152.5,505.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.3,438.3c0,3.5-2.8,6.4-6.3,6.4c-3.5,0-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C87.4,432,90.3,434.8,90.3,438.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M128.3,441.4c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C125.5,435.1,128.3,437.9,128.3,441.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M138.8,464.9c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C135.9,458.6,138.8,461.4,138.8,464.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M121,452.2c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0C118.2,445.9,121,448.7,121,452.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M95.5,449.9c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C92.6,443.5,95.5,446.4,95.5,449.9C95.5,449.9,95.5,449.9,95.5,449.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115.6,440.3c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C112.8,434,115.6,436.8,115.6,440.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143.8,480.3c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C140.9,474,143.8,476.8,143.8,480.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M131.7,475.9c0,3.5-2.8,6.4-6.3,6.4c-3.5,0-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C128.8,469.5,131.7,472.3,131.7,475.9C131.7,475.8,131.7,475.8,131.7,475.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M126.2,464.2c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C123.4,457.8,126.2,460.6,126.2,464.2C126.2,464.2,126.2,464.2,126.2,464.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M133.5,453.4c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C130.7,447,133.5,449.8,133.5,453.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.2,450.7c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C105.3,444.4,108.2,447.2,108.2,450.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M102.8,438.9c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3l0,0 C100,432.6,102.8,435.4,102.8,438.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M147.2,492.6c0,3.5-2.8,6.3-6.3,6.4c-3.5,0-6.3-2.8-6.4-6.3c0-3.5,2.8-6.3,6.3-6.4c0,0,0,0,0,0 C144.3,486.3,147.2,489.1,147.2,492.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M127.1,406.8c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C124.3,400.4,127.1,403.3,127.1,406.8C127.1,406.8,127.1,406.8,127.1,406.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M121.6,395.5c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C118.8,389.1,121.6,392,121.6,395.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.3,413c0,3.5-2.9,6.3-6.4,6.3c-3.5,0-6.3-2.9-6.3-6.4c0-3.5,2.9-6.3,6.4-6.3 C102.5,406.6,105.3,409.5,105.3,413C105.3,413,105.3,413,105.3,413"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M101.1,403c0,3.5-2.8,6.4-6.3,6.4c-3.5,0-6.4-2.8-6.4-6.3s2.8-6.4,6.3-6.4c0,0,0,0,0,0 C98.2,396.7,101.1,399.5,101.1,403"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M111.8,391.3c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3l0,0 C108.9,385,111.8,387.8,111.8,391.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M113.7,401.1c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C110.9,394.8,113.7,397.6,113.7,401.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M133.2,419.8c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C130.4,413.5,133.2,416.3,133.2,419.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M117,413.7c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C114.2,407.3,117,410.2,117,413.7C117,413.7,117,413.7,117,413.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M97.2,427.4c0,3.5-2.9,6.3-6.4,6.3s-6.3-2.9-6.3-6.4c0-3.5,2.9-6.3,6.4-6.3C94.4,421,97.2,423.8,97.2,427.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M93,411.9c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0C90.2,405.6,93,408.4,93,411.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.2,428.6c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3l0,0 C107.3,422.3,110.1,425.1,110.2,428.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123,429.7c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0C120.2,423.4,123,426.2,123,429.7 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M187.1,384.3c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C184.3,378,187.1,380.8,187.1,384.3C187.1,384.3,187.1,384.3,187.1,384.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M122.6,383.5c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.4c0-3.5,2.8-6.3,6.3-6.3 C119.8,377.1,122.6,380,122.6,383.5C122.6,383.5,122.6,383.5,122.6,383.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M188.1,161.3c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C185.3,154.9,188.1,157.8,188.1,161.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M188.5,440.4c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C185.7,434,188.5,436.9,188.5,440.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M182.5,432.3c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C179.7,426,182.5,428.8,182.5,432.3C182.5,432.3,182.5,432.3,182.5,432.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M180.5,418.3c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C177.7,411.9,180.5,414.8,180.5,418.3C180.5,418.3,180.5,418.3,180.5,418.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M177.7,406.2c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C174.8,399.9,177.7,402.7,177.7,406.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M190.7,398.1c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C187.9,391.8,190.7,394.6,190.7,398.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198.6,365.7c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C195.7,359.4,198.6,362.2,198.6,365.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M183.8,363.6c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C180.9,357.2,183.8,360.1,183.8,363.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M182.5,352.9c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C179.7,346.6,182.5,349.4,182.5,352.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M194.8,350c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C192,343.7,194.8,346.5,194.8,350"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M185.6,344.3c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C182.8,338,185.6,340.8,185.6,344.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M186.6,332.6c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C183.8,326.3,186.6,329.1,186.6,332.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M84.2,327.1c2.7,2.2,3.1,6.2,0.9,8.9c-2.2,2.7-6.2,3.1-8.9,0.9c-2.7-2.2-3.1-6.2-0.9-8.9 C77.4,325.3,81.4,324.9,84.2,327.1C84.2,327.1,84.2,327.1,84.2,327.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M80.1,315c2.7,2.2,3.1,6.2,0.9,8.9s-6.2,3.1-8.9,0.9c-2.7-2.2-3.1-6.2-0.9-8.9 C73.4,313.2,77.4,312.8,80.1,315C80.1,315,80.1,315,80.1,315"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M96,331.6c2.7,2.2,3.1,6.2,0.9,8.9c-2.2,2.7-6.2,3.1-8.9,0.9c-2.7-2.2-3.1-6.2-0.9-8.9 C89.3,329.8,93.3,329.4,96,331.6C96,331.6,96,331.6,96,331.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M103.4,342.1c2.7,2.2,3.1,6.2,0.9,8.9s-6.2,3.1-8.9,0.9c-2.7-2.2-3.1-6.2-0.9-8.9 C96.7,340.3,100.7,339.9,103.4,342.1C103.4,342,103.4,342.1,103.4,342.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M192.1,313.2c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C189.3,306.8,192.1,309.7,192.1,313.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M188.4,323.5c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C185.6,317.1,188.4,319.9,188.4,323.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M180.6,290.9c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C177.8,284.5,180.6,287.4,180.6,290.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M171.8,226c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C169,219.7,171.8,222.5,171.8,226"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M176.7,215.5c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C173.8,209.2,176.7,212,176.7,215.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M188.9,212c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C186,205.7,188.9,208.5,188.9,212"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M176.4,235.8c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C173.6,229.4,176.4,232.3,176.4,235.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M178.7,245.9c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C175.8,239.6,178.7,242.4,178.7,245.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M180.4,257.5c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C177.6,251.1,180.4,254,180.4,257.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M184.8,275.4c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C181.9,269,184.8,271.9,184.8,275.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M190.2,199.6c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C187.4,193.3,190.2,196.1,190.2,199.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M194.1,191.3c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C191.3,185,194.1,187.8,194.1,191.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198.1,182.1c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C195.3,175.8,198.1,178.6,198.1,182.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M189.1,173.9c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C186.3,167.5,189.1,170.4,189.1,173.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M180,126.8c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C177.2,120.4,180,123.2,180,126.8C180,126.7,180,126.7,180,126.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M121.8,127.2c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3h0 C119,120.9,121.8,123.7,121.8,127.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.7,164c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3l0,0 C107.8,157.7,110.6,160.5,110.7,164"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M100.8,155.7c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C98,149.4,100.8,152.2,100.8,155.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.1,131.4c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C107.2,125,110.1,127.9,110.1,131.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M113.4,123c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3l0,0 C110.6,116.7,113.4,119.5,113.4,123"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M119.4,134.7c0,3.5-2.8,6.4-6.3,6.4s-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C116.6,128.4,119.4,131.2,119.4,134.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.3,156.4c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3l0,0 C111.4,150,114.3,152.9,114.3,156.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M71.1,226c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C68.3,219.7,71.1,222.5,71.1,226"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M80.1,224.9c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C77.2,218.5,80.1,221.3,80.1,224.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M88.6,229.7c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C85.8,223.4,88.6,226.2,88.6,229.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M74.2,235c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C71.4,228.7,74.2,231.5,74.2,235"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M74.6,215.6c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h0 C71.8,209.3,74.6,212.1,74.6,215.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M87.2,216.6c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3l0,0 C84.3,210.3,87.1,213.1,87.2,216.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M78.8,207.1c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3l0,0 C76,200.7,78.8,203.6,78.8,207.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.8,198.2c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3l0,0 C87.9,191.8,90.8,194.7,90.8,198.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M100.4,178.1c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C97.6,171.8,100.4,174.6,100.4,178.1C100.5,178.1,100.5,178.1,100.4,178.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M99.2,195.1c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3l0,0 C96.4,188.8,99.2,191.6,99.2,195.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M121.2,104.1c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3l0,0 C118.4,97.8,121.2,100.6,121.2,104.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M130.8,107.7c0,3.5-2.8,6.4-6.3,6.4c-3.5,0-6.4-2.8-6.4-6.3c0-3.5,2.8-6.4,6.3-6.4c0,0,0,0,0,0 C128,101.3,130.8,104.1,130.8,107.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M161.4,28.8c0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3C158.5,22.4,161.3,25.3,161.4,28.8 C161.3,28.8,161.3,28.8,161.4,28.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M199.2,127.7c0.4,3.5-2.1,6.6-5.6,7c-3.5,0.4-6.6-2.1-7-5.6s2.1-6.6,5.6-7c0,0,0,0,0,0 C195.6,121.7,198.8,124.2,199.2,127.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M200.7,118c0.4,3.5-2.1,6.6-5.6,7s-6.6-2.1-7-5.6c-0.4-3.5,2.1-6.6,5.6-7c0,0,0,0,0,0 C197.1,112,200.3,114.5,200.7,118"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M209.2,119c0.4,3.5-2.1,6.6-5.6,7c-3.5,0.4-6.6-2.1-7-5.6c-0.4-3.5,2.1-6.6,5.6-7c0,0,0,0,0,0 C205.7,113,208.8,115.5,209.2,119"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M205.5,97.5c0.4,3.5-2.1,6.6-5.6,7s-6.6-2.1-7-5.6c-0.4-3.5,2.1-6.6,5.6-7c0,0,0,0,0,0 C201.9,91.5,205.1,94,205.5,97.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M205.1,89.2c0.4,3.5-2.1,6.6-5.6,7s-6.6-2.1-7-5.6c-0.4-3.5,2.1-6.6,5.6-7c0,0,0,0,0,0 C201.6,83.3,204.7,85.8,205.1,89.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M204,75.1c0.4,3.5-2.1,6.6-5.6,7s-6.6-2.1-7-5.6c-0.4-3.5,2.1-6.6,5.6-7c0,0,0,0,0,0 C200.5,69.1,203.6,71.6,204,75.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M204.5,64.9c0.4,3.5-2.1,6.6-5.6,7s-6.6-2.1-7-5.6c-0.4-3.5,2.1-6.6,5.6-7c0,0,0,0,0,0 C201,58.9,204.1,61.4,204.5,64.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M200.2,52.4c0.4,3.5-2.1,6.6-5.6,7s-6.6-2.1-7-5.6s2.1-6.6,5.6-7c0,0,0,0,0,0C196.7,46.5,199.9,49,200.2,52.4 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M194.5,41c0.4,3.5-2.1,6.6-5.6,7s-6.6-2.1-7-5.6s2.1-6.6,5.6-7c0,0,0,0,0,0C191,35,194.1,37.5,194.5,41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M186.5,35.5c0.4,3.5-2.1,6.6-5.6,7c-3.5,0.4-6.6-2.1-7-5.6s2.1-6.6,5.6-7c0,0,0,0,0,0 C183,29.6,186.1,32.1,186.5,35.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M208.2,106c0.4,3.5-2.1,6.6-5.6,7s-6.6-2.1-7-5.6c-0.4-3.5,2.1-6.6,5.6-7c0,0,0,0,0,0 C204.6,100,207.8,102.5,208.2,106"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M150.4,27.8c0,3.5-2.8,6.3-6.4,6.3s-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3C147.6,21.4,150.4,24.3,150.4,27.8 C150.4,27.8,150.4,27.8,150.4,27.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M154.8,21c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3l0,0C152,14.7,154.8,17.5,154.8,21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M161.3,7.7c0,3.5-2.8,6.4-6.3,6.4c-3.5,0-6.4-2.8-6.4-6.3s2.8-6.4,6.3-6.4c0,0,0,0,0,0 C158.5,1.3,161.3,4.2,161.3,7.7C161.4,7.7,161.4,7.7,161.3,7.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik13);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_13.2c5bcf889be07358dc97de2c5871a24a.svg";
export { ForwardRef as ReactComponent };